require('./teamLineupController');

'use strict';

angular.module('app.shared.teamLineup.teamLineupDirective', [
    'app.shared.teamLineup.teamLineupController'
])
    .directive('teamLineup', [
        function () {
            return {
                restrict: 'E',
                template: '<div ng-include src="get_template_url()"></div>',
                controller: 'app.shared.teamLineup.teamLineupController',
                scope: {
                    game: '<',
                    layout: '@',
                    version: '<'
                },
                link: function (scope, elm) {
                    elm.addClass('team-lineup');

                    if(!scope.version) {
                        scope.version = 1;
                    }
                    elm.addClass('version-' + scope.version);
                }
            };
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/shared/teamLineup/teamLineupDirective.js